import {
  Globe,
  LayoutDashboard,
  CloudCog,
  Settings2,
  Cpu,
  Smartphone,
  Search,
  Wrench,
} from "lucide-react";

export const COMPANY_V2_SERVICES = [
  {
    id: "corporate",
    title: "기업 홈페이지 제작",
    en: "Corporate Website",
    desc: "브랜드의 첫인상을 결정짓는 프리미엄 기업 사이트.",
    Icon: Globe,
    backIntro: "기업의 신뢰도를 높이고 브랜드 가치를 전달하는 맞춤형 홈페이지를 제작합니다.",
    features: [
      "회사소개 및 사업소개 페이지",
      "문의 접수 및 상담 신청 기능",
      "반응형 웹 지원(PC·태블릿·모바일)",
      "검색엔진 최적화(SEO)",
      "브랜드 아이덴티티 반영 디자인",
    ],
    audience: "스타트업, 중소기업, 법인기업, 전문 서비스 기업",
  },
  {
    id: "platform",
    title: "웹 플랫폼 개발",
    en: "Web Platform",
    desc: "비즈니스 로직 중심의 확장 가능한 웹 플랫폼.",
    Icon: LayoutDashboard,
    backIntro: "회원가입부터 예약, 결제, 커뮤니티까지 다양한 기능을 하나의 플랫폼으로 구축합니다.",
    features: [
      "회원 관리 시스템",
      "예약 및 신청 시스템",
      "결제 연동",
      "게시판 및 커뮤니티",
      "관리자 페이지 제공",
    ],
    audience: "교육 플랫폼, 예약 플랫폼, 매칭 서비스, 커뮤니티 서비스",
  },
  {
    id: "edu",
    title: "SaaS(Software as a Service) 구축",
    en: "SaaS",
    desc: "구독·멀티테넌트·과금까지 통합된 클라우드 서비스 솔루션.",
    Icon: CloudCog,
    backIntro: "고객이 월 구독 형태로 사용하는 웹 서비스를 구축합니다.",
    features: [
      "구독 결제 시스템",
      "이용권 관리",
      "사용자별 권한 관리",
      "통계 및 데이터 분석",
      "확장 가능한 클라우드 구조",
    ],
    audience: "AI 서비스, 업무관리 솔루션, 구독형 플랫폼",
  },
  {
    id: "cms",
    title: "관리자 CMS 개발",
    en: "Admin CMS",
    desc: "운영자의 생산성을 끌어올리는 맞춤형 관리자 시스템.",
    Icon: Settings2,
    backIntro: "개발자 도움 없이 직접 콘텐츠를 관리할 수 있는 관리자 시스템을 제공합니다.",
    features: [
      "공지사항 관리",
      "이미지 및 배너 관리",
      "회원 관리",
      "문의 관리",
      "통계 확인",
    ],
    audience: "콘텐츠가 자주 변경되는 기업 및 플랫폼",
  },
  {
    id: "ai",
    title: "AI 자동화 시스템",
    en: "AI Automation",
    desc: "LLM·RPA 기반 업무 자동화와 워크플로우 설계.",
    Icon: Cpu,
    backIntro: "반복 업무를 AI가 대신 처리하여 운영 효율을 높입니다.",
    features: [
      "AI 챗봇 구축",
      "자동 상담 응대",
      "문서 자동 생성",
      "예약 자동 처리",
      "업무 자동화 워크플로우",
    ],
    audience: "고객 문의가 많은 기업, 교육기관, 예약 서비스",
  },
  {
    id: "uiux",
    title: "반응형 UI / UX 설계",
    en: "Responsive UI/UX",
    desc: "디바이스 경계 없는 일관된 사용자 경험.",
    Icon: Smartphone,
    backIntro: "어떤 기기에서도 편리하게 사용할 수 있는 사용자 경험을 설계합니다.",
    features: [
      "모바일 최적화",
      "태블릿 최적화",
      "사용자 동선 설계",
      "직관적인 인터페이스",
      "접근성 고려",
    ],
    audience: "모든 웹사이트 및 플랫폼",
  },
  {
    id: "seo",
    title: "SEO 최적화",
    en: "SEO Optimization",
    desc: "코어 웹 바이탈 기반의 검색 가시성 확보.",
    Icon: Search,
    backIntro: "검색 결과 상위 노출을 위한 사이트 구조를 설계합니다.",
    features: [
      "네이버 SEO",
      "구글 SEO",
      "사이트 속도 개선",
      "검색 노출 구조 최적화",
      "콘텐츠 전략 설계",
    ],
    audience: "검색 유입이 중요한 기업 및 브랜드",
  },
  {
    id: "ops",
    title: "유지보수 및 기능 확장",
    en: "Maintenance",
    desc: "출시 이후의 안정성과 점진적 기능 확장.",
    Icon: Wrench,
    backIntro: "서비스 오픈 이후에도 안정적인 운영과 지속적인 개선을 지원합니다.",
    features: [
      "오류 수정",
      "기능 추가",
      "디자인 개선",
      "보안 업데이트",
      "서버 관리 지원",
    ],
    audience: "장기적으로 서비스를 운영하는 모든 기업",
  },
];
